import React, { useState } from 'react';
import { Button, Modal } from '@mantine/core';

// Vervanger van de Cyclomedia StreetSmart-viewer (toegang vervallen).
// Toont een Google Maps satelliet-embed van de stationslocatie; de knop opent
// Google Street View op die plek als overlay (Modal) over de site. Beide werken
// zonder Google-API-key; een betaalde Maps-key kan dit later rijker maken.
export default function GoogleMapsViewer({ lat, lng }) {
  const [svOpen, setSvOpen] = useState(false);
  const embedUrl = `https://maps.google.com/maps?q=${lat},${lng}&z=19&t=k&hl=nl&output=embed`;
  // Keyless Street View-embed (pano) — rendert binnen een iframe zonder API-key.
  const streetViewEmbed = `https://maps.google.com/maps?layer=c&cbll=${lat},${lng}&cbp=11,0,0,0,0&output=svembed&hl=nl`;

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {/* Vaste hoogte + overflow hidden en een groter, opgeschoven iframe: de
          onderrand (Kaartgegevens/Gebruiksvoorwaarden/sneltoetsen + zoomknoppen)
          en de bovenrand worden weggesneden. pointer-events uit = geen bediening. */}
      <div style={{ position: 'relative', width: '100%', height: 220, overflow: 'hidden' }}>
        <iframe
          title="Google Maps locatie"
          src={embedUrl}
          style={{
            width: '100%', height: 310, border: 0, display: 'block',
            marginTop: -22, pointerEvents: 'none',
          }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <Button
        size="compact-xs" variant="white" color="dark"
        style={{ position: 'absolute', bottom: 8, right: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.3)' }}
        onClick={() => setSvOpen(true)}
      >
        Street View
      </Button>
      <Modal
        opened={svOpen} onClose={() => setSvOpen(false)}
        size="90%" centered padding={0} withCloseButton={false}
      >
        <iframe
          title="Google Street View"
          src={streetViewEmbed}
          style={{ width: '100%', height: '75vh', border: 0, display: 'block' }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Modal>
    </div>
  );
}
